<div class="modal-overlay" *ngIf="isVisible" (click)="cerrarModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Tratamiento de Datos Personales</h2>
      <button class="modal-close-btn" (click)="cerrarModal()" aria-label="Cerrar">
        <span>&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <app-tratamiento-datos></app-tratamiento-datos>
    </div>

    <div class="modal-footer">
      <button class="btn-cerrar" (click)="cerrarModal()">Cerrar</button>
    </div>
  </div>
</div>
